export const MEASUREMENTS = {
	SMALL_MOBILE: 375,
	MOBILE: 415,
	PHABLET: 640,
	TABLET: 840,
	DESKTOP: 1025,
	WIDE: 1300
};